export default __webpack_public_path__ + "static/media/bbUSD+.a32e33cb.webp";